import { graphql, OptionProps } from 'react-apollo';
import { compose, setDisplayName } from 'recompose';
import configureApolloClient from '../../apollo/configureApolloClient';
import { ActivityStreamInfoQuery, AthleteQuery } from './queries';
import {
    ActivityStreamInfoPayload,
    AthletePayload,
    AthleteProps
} from './types';

export async function fetchAthlete() {
    const client = configureApolloClient();

    const results = await client.query({
        query: AthleteQuery
    });
    return results;
}

const withAthlete = compose<AthleteProps, any>(
    setDisplayName('withAthlete'),
    graphql<any, AthletePayload, any, AthleteProps>(AthleteQuery, {
        props: (props: OptionProps<any, AthletePayload>): AthleteProps => {
            const { data, ownProps } = props;
            if (data) {
                const {
                    loggedInUser,
                    error,
                    loading,
                    activityStreamInfoList
                } = data;
                return {
                    ...ownProps,
                    activityStreamInfoList,
                    error,
                    loading,
                    loggedInUser
                };
            }
            throw new Error('No athlete provided');
        }
    })
);

export const withActivityStreamInfo = graphql<
    any,
    ActivityStreamInfoPayload,
    any,
    AthleteProps
>(ActivityStreamInfoQuery, {
    props: (props: OptionProps<any, any>): AthleteProps => {
        const { data, ownProps } = props;
        if (data) {
            const { error, loading, activityStreamInfoList } = data;
            return {
                ...ownProps,
                activityStreamInfoList,
                error,
                loading
            };
        }
        throw new Error('No athlete provided');
    }
});

export default withAthlete;



// WEBPACK FOOTER //
// ./src/client/components/Strava/withAthlete.tsx